import { authoringRoute } from "authoring/routes/authoring.runtime"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { hasDemand } from "lib/authorization/has-demand"
import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { Box, Typography } from "@mui/material"
import { ClientRoleConfiguration } from "routes/client-admin/plugins/permissions/client-roles"
import { getAuthoringGlobalDemands } from "authoring/users/controller/get-authoring-global-demands"
import { UserRolesTitle } from "slot-definitions"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { AUTHORING_MANAGE_GLOBAL_ROLES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

authoringRoute.register(
    "roles",
    <DemandGuard demands={[AUTHORING_MANAGE_GLOBAL_ROLES_DEMAND]}>
        <AuthoringGlobalRoles $lazy />
    </DemandGuard>
)

registerConditionalPageNavigation(
    () => hasDemand(AUTHORING_MANAGE_GLOBAL_ROLES_DEMAND) && hasDemand("!sharing"),
    "/authoring/roles",
    "Roles",
    "fluent:shield-settings-20-filled",
    {
        group: "Admin",
        priority: 580,
    }
)

function AuthoringGlobalRoles() {
    const authoringDemands = getAuthoringGlobalDemands.useResults()
    UserRolesTitle.usePlug(
        replaceAllWith(
            <Typography component="div" variant="h4" sx={{ ml: -1, mb: 4 }}>
                Permissions
            </Typography>
        )
    )
    return (
        <PageBreadcrumbContainer title={"Roles"}>
            <Box flex={1}>
                <ClientRoleConfiguration selectableDemands={authoringDemands} type="authoring:global" />
            </Box>
        </PageBreadcrumbContainer>
    )
}
